import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { UploadIcon, TrashIcon } from "@radix-ui/react-icons";
import { cn } from "../lib/utils";
import { Button } from "./ui/button"; // ShadCN Button Component

function FileUpload({
  setFiles,
  files,
  multiple = false,
  accept = "*",
  //   onFilesSelected,
}) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (multiple) {
        setFiles((prev) =>
          prev ? [...prev, ...acceptedFiles] : [...acceptedFiles],
        );
      } else {
        setFiles(acceptedFiles.slice(0, 1)); // Only keep the first file for single upload
      }

      //   if (onFilesSelected) {
      //     onFilesSelected(
      //       multiple ? [...files, ...acceptedFiles] : acceptedFiles.slice(0, 1)
      //     );
      //   }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [multiple, files],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: accept ? { [accept]: [] } : undefined, // Dynamically set accepted file types
    multiple,
  });

  const removeFile = (file) => {
    setFiles((prev) => prev.filter((f) => f !== file));
  };

  return (
    <div className="w-full max-w-md mx-auto border-dashed border-2 rounded-md">
      {/* Drag and Drop Area */}
      <div
        {...getRootProps()}
        className={cn(
          "flex flex-col items-center justify-center border-2 border-dashed rounded-lg p-6 transition-all cursor-pointer",
          isDragActive
            ? "border-primary bg-accent"
            : "border-muted bg-background",
        )}
      >
        <input {...getInputProps()} />
        <UploadIcon className="h-10 w-10 text-muted-foreground" />
        <p className="text-sm text-muted-foreground mt-2">
          {multiple
            ? "Drag & drop files here, or click to select"
            : "Drag & drop a file here, or click to select"}
        </p>
      </div>

      {/* File List */}
      {files?.length > 0 && (
        <div className="mt-4">
          <p className="text-sm font-medium text-muted-foreground mb-2">
            Uploaded {multiple ? "Files" : "File"}:
          </p>
          <ul className="space-y-2">
            {files?.map((file, index) => (
              <li
                key={index}
                className="flex items-center justify-between p-2 border rounded-md"
              >
                <span className="text-sm truncate max-w-[80%]">
                  {file.name}
                </span>
                <Button
                  size="icon"
                  variant="ghost"
                  className="text-red-500 hover:text-red-700"
                  onClick={() => removeFile(file)}
                >
                  <TrashIcon className="h-4 w-4" />
                </Button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default FileUpload;
